var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("ticket.title"),
        visible: _vm.visible,
        "append-to-body": "",
        "custom-class": "support-ticket-dialog",
        "z-index": 100001,
        top: "5vh",
        "close-on-click-modal": false,
        "close-on-press-escape": !_vm.submitting,
        "show-close": !_vm.submitting,
        "before-close": _vm.beforeClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _vm.loading
        ? _c("div", { attrs: { role: "status" } }, [
            _vm._v(_vm._s(_vm.$t("ticket.loading"))),
          ])
        : _vm.loadError
        ? _c(
            "div",
            { attrs: { role: "alert" } },
            [
              _c("p", [_vm._v(_vm._s(_vm.loadError))]),
              _c("el-button", { on: { click: _vm.loadFields } }, [
                _vm._v(_vm._s(_vm.$t("ticket.retry"))),
              ]),
            ],
            1
          )
        : _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.values,
                "label-position": "top",
                disabled: _vm.submitting,
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.submit.apply(null, arguments)
                },
              },
            },
            [
              _vm._l(_vm.visibleFields, function (field) {
                return _c(
                  "el-form-item",
                  {
                    key: field.id,
                    attrs: {
                      prop: String(field.id),
                      rules: _vm.rules(field),
                      label:
                        field.type === "checkbox"
                          ? undefined
                          : _vm.label(field),
                    },
                  },
                  [
                    field.type === "checkbox"
                      ? _c(
                          "el-checkbox",
                          {
                            staticClass: "ticket-checkbox",
                            model: {
                              value: _vm.values[field.id],
                              callback: function ($$v) {
                                _vm.$set(_vm.values, field.id, $$v)
                              },
                              expression: "values[field.id]",
                            },
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.label(field)) +
                                _vm._s(_vm.required(field) ? " *" : "") +
                                "\n      "
                            ),
                          ]
                        )
                      : _vm.isSelect(field)
                      ? _c(
                          "el-select",
                          {
                            attrs: {
                              multiple: field.type === "multiselect",
                              filterable: "",
                              clearable: "",
                              placeholder: _vm.$t("ticket.select"),
                            },
                            model: {
                              value: _vm.values[field.id],
                              callback: function ($$v) {
                                _vm.$set(_vm.values, field.id, $$v)
                              },
                              expression: "values[field.id]",
                            },
                          },
                          _vm._l(_vm.options(field), function (option) {
                            return _c("el-option", {
                              key: option.value,
                              attrs: {
                                label: option.name,
                                value: option.value,
                              },
                            })
                          }),
                          1
                        )
                      : field.type === "date"
                      ? _c("el-date-picker", {
                          attrs: { type: "date", "value-format": "yyyy-MM-dd" },
                          model: {
                            value: _vm.values[field.id],
                            callback: function ($$v) {
                              _vm.$set(_vm.values, field.id, $$v)
                            },
                            expression: "values[field.id]",
                          },
                        })
                      : _c("el-input", {
                          attrs: {
                            type: ["description", "textarea"].includes(
                              field.type
                            )
                              ? "textarea"
                              : "text",
                            rows: 4,
                          },
                          model: {
                            value: _vm.values[field.id],
                            callback: function ($$v) {
                              _vm.$set(_vm.values, field.id, $$v)
                            },
                            expression: "values[field.id]",
                          },
                        }),
                    field.description
                      ? _c("p", { staticClass: "ticket-description" }, [
                          _vm._v(_vm._s(field.description)),
                        ])
                      : _vm._e(),
                  ],
                  1
                )
              }),
              _vm.submitError
                ? _c(
                    "p",
                    { staticClass: "ticket-error", attrs: { role: "alert" } },
                    [_vm._v(_vm._s(_vm.submitError))]
                  )
                : _vm._e(),
            ],
            2
          ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { disabled: _vm.submitting },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("ticket.cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                loading: _vm.submitting,
                disabled: _vm.loading || !!_vm.loadError,
              },
              on: { click: _vm.submit },
            },
            [_vm._v(_vm._s(_vm.$t("ticket.submit")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }